import React from "react";
import { HStack, Switch, Text } from "@chakra-ui/react";

export default function HeaderBar({ customerVersion, onToggleCustomerVersion }) {
  return (
    <HStack align="center" spacing={8} mb={6}>
      <Text fontSize="2xl" fontWeight="bold">
        Crea Quotazione
      </Text>
      <HStack spacing={2}>
        <Text fontSize="sm" fontWeight="bold" mt={2}>
          Versione cliente
        </Text>
        <Switch
          size="md"
          isChecked={customerVersion}
          onChange={onToggleCustomerVersion}
        />
      </HStack>
    </HStack>
  );
}
